import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'siq-js-comparison-dates',
  templateUrl: './comparison-dates.component.html',
  styleUrls: ['./comparison-dates.component.scss']
})
export class ComparisonDatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
